import React from "react";
import { useReveal } from "@/hooks/useReveal";

export default function Philosophy() {
  const ref = useReveal();

  return (
    <section
      id="filosofia"
      ref={ref}
      className="relative bg-[var(--luft-bg)] py-32 sm:py-40 lg:py-48 overflow-hidden"
      data-testid="philosophy-section"
    >
      {/* Soft ambient sky wash */}
      <div
        className="pointer-events-none absolute top-1/3 -left-32 w-[45vw] h-[45vw] rounded-full opacity-[0.24]"
        style={{
          background:
            "radial-gradient(circle, rgba(181,199,211,0.65) 0%, transparent 70%)",
        }}
        aria-hidden="true"
      />

      <div className="relative max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-14 lg:gap-x-12">
          {/* Left column — number + accent image + italic pull-quote */}
          <div className="col-span-12 lg:col-span-5 reveal">
            <p className="eyebrow mb-8" data-testid="philosophy-eyebrow">
              01 — O Lu.ft
            </p>

            <div
              className="relative overflow-hidden mb-10"
              style={{ borderRadius: "var(--radius-organic)" }}
            >
              <img
                src="/media/luft-detail-shoulder.jpg"
                alt="Detalhe · presença no movimento"
                loading="lazy"
                className="w-full aspect-[4/5] object-cover"
                style={{ filter: "brightness(1.02) saturate(1.03)" }}
              />
            </div>

            <p className="font-display italic text-[var(--luft-ink)] text-2xl sm:text-3xl leading-snug">
              Um estúdio íntimo.<br />
              Um <em>ritmo próprio</em>.
            </p>
          </div>

          {/* Right column — big statement + editorial paragraphs */}
          <div className="col-span-12 lg:col-span-7 lg:pl-6 lg:pt-24 reveal">
            <h2
              className="editorial-heading text-[clamp(2.2rem,5.4vw,4.6rem)] text-[var(--luft-ink)] mb-12 leading-[0.98]"
              data-testid="philosophy-title"
            >
              Acreditamos no corpo que <em className="editorial-italic">respira</em>,
              que escuta, que se move com <em className="editorial-italic">intenção</em>.
            </h2>

            <div className="grid sm:grid-cols-2 gap-10 sm:gap-12 text-[var(--luft-ink-soft)] font-body font-light text-[1rem] leading-[1.78]">
              <p>
                O Lu.ft nasce do desejo de oferecer um espaço pequeno, atento e
                cuidado, onde cada gesto importa. Trabalhamos em grupos
                reduzidos, com escuta próxima, para que cada aluno encontre o
                seu próprio caminho de prática.
              </p>
              <p>
                Não procuramos rotinas exigentes nem performance. Procuramos
                <em className="editorial-italic"> consciência</em> — uma forma
                calma e precisa de habitar o corpo, dia após dia, sem pressa.
              </p>
            </div>

            <div className="mt-16 grid grid-cols-3 gap-6 sm:gap-12">
              {[
                { k: "07", v: "alunos · matwork" },
                { k: "04", v: "alunos · reformer" },
                { k: "2022", v: "ano de fundação" },
              ].map((item) => (
                <div
                  key={item.k}
                  className="border-t border-[var(--luft-line)] pt-5"
                >
                  <p className="font-display text-3xl sm:text-4xl text-[var(--luft-ink)]">
                    {item.k}
                  </p>
                  <p className="eyebrow mt-3">{item.v}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
